import type { SupportedRepubName } from './types';

export type LogoConfig = {
  alt: string;
  mobileSrc?: (resourcesUrl: string) => string;
  src: (resourcesUrl: string) => string;
  style?: React.CSSProperties;
} | null;

export type ErrorPageConfig = {
  backgroundColor: string;
  customComponent?: string; // Component identifier (e.g., 'ErrorWhoScored')
  redirectUrl?: string; // URL to redirect to on 404 (e.g., for GZ)
};

/**
 * Logo configurations for each republic
 */
export const LOGO_CONFIGS = {
  WS: {
    alt: 'WhoScored',
    src: (resourcesUrl: string) => `${resourcesUrl}/assets/img/ws-logo-white.png`,
    style: { maxWidth: '180px', maxHeight: '75px' },
  },
  US: {
    alt: 'OddsChecker',
    src: (resourcesUrl: string) => `${resourcesUrl}/assets/img/oc-pro-logo.svg`,
    style: {},
  },
  OC: {
    alt: 'OddsChecker',
    src: (resourcesUrl: string) => `${resourcesUrl}/assets/img/oc-pro-logo.svg`,
    style: {},
  },
  GZ: {
    alt: 'Gazetta',
    src: (resourcesUrl: string) => `${resourcesUrl}/assets/img/gazzetta-logo.svg`,
    mobileSrc: (resourcesUrl: string) => `${resourcesUrl}/assets/img/gazzetta-logo-mobile.svg`,
    style: {},
  },
} satisfies Record<SupportedRepubName, LogoConfig>;

/**
 * Error page configurations for each republic
 */
export const ERROR_PAGE_CONFIGS = {
  WS: {
    backgroundColor: '#2d2d2d',
    customComponent: 'ErrorWhoScored',
  },
  GZ: {
    backgroundColor: '#f5f5f5',
    redirectUrl: 'https://www.gazzetta.it/404.shtml',
  },
} satisfies Partial<Record<SupportedRepubName, ErrorPageConfig>>;

/**
 * Logo URL configurations for each republic
 */
export const LOGO_URL_CONFIGS = {
  WS: 'https://www.whoscored.com',
} satisfies Partial<Record<SupportedRepubName, string>>;
